import c from "classnames";
import { PropsWithChildren } from "react";

import { Tab } from "./UI/Tab/Tab";

import classes from "./Tabs.module.css";

type Props = PropsWithChildren<{
  className?: string;
  style?: React.CSSProperties;
}>;

export const Tabs = ({ children, className, style }: Props) => {
  return (
    <div className={c(classes.tabs, className)} style={style}>
      {children}
    </div>
  );
};

Tabs.Tab = Tab;
